// Cache Abstraction Layer
export default Barba.BaseCache;